module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/dinner-course-photo-2-3-e2a8cee19876d645f40a77e9e20f2dcc.jpg";